export const getReasonIsPlanned = (reason) => {
  const plannedKey = Object.keys(reason || {}).find((key) => {
    const normalizedKey = key.replace(/[^a-z0-9]/gi, '').toLowerCase();
    return normalizedKey === 'isplanned' || normalizedKey === 'isplaned';
  });

  if (!plannedKey || reason[plannedKey] === undefined || reason[plannedKey] === null) {
    return null;
  }

  if (typeof reason[plannedKey] === 'boolean') {
    return reason[plannedKey];
  }

  return String(reason[plannedKey]).trim().toLowerCase() === 'true';
};

export const getPlannedValue = (reason, downtimeReasons) => {
  if (
    !reason
    || !Array.isArray(downtimeReasons)
    || !reason.reasoncode
    || !reason.reasonname
    || !reason.department
  ) {
    return null;
  }

  const reasonCode = String(reason.reasoncode).trim().toLowerCase();
  const reasonName = String(reason.reasonname).trim().toLowerCase();
  const department = String(reason.department).trim().toLowerCase();

  const matchedReason = downtimeReasons.find((item) => (
    String(item.reasoncode || '').trim().toLowerCase() === reasonCode
    && String(item.reasonname || '').trim().toLowerCase() === reasonName
    && String(item.department || '').trim().toLowerCase() === department
  ));

  if (!matchedReason) {
    return null;
  }

  return getReasonIsPlanned(matchedReason);
};
